import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useAuth, isStaffRole, homePathFor } from '../context/AuthContext';

// Protects staff pages. Without allowedRoles any admin or tech may enter.
// Can wrap child routes (<Outlet />) or a single element via children.
const ProtectedRoute = ({ allowedRoles, children }) => {
  const { currentUser, userRole } = useAuth();
  const { lang = 'ar' } = useParams();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to={`/${lang}/login`} replace state={{ from: location.pathname }} />;
  }

  const allowed = allowedRoles ? allowedRoles.includes(userRole) : isStaffRole(userRole);
  if (!allowed) {
    // Staff go to their own dashboard; anyone else back to the website.
    return <Navigate to={homePathFor(userRole, lang)} replace />;
  }

  return children ?? <Outlet />;
};

export default ProtectedRoute;
